import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Map } from "immutable";
import { Col } from "react-bootstrap";
import {
  Field,
  formValueSelector,
  change,
  Fields,
  FormSection
} from "redux-form";
import api from "APP_ROOT/api";
import { dollars } from "LIB/formatters/currency";
import {
  AsIsField,
  exchangeSrpNotAllowed,
  ExchangeSrpWarning,
  LineHazmatFields,
  SRP_CONDITION_OPTIONS,
  UnauthorizedPreferredRepairStationSelectedWarning,
  UnauthorizedRepairStationSelectedWarning
} from "MODULES/PurchaseOrders/components/Detail/LineItemsTable/Form";
import { SRPConditionMismatchWarning } from "MODULES/PurchaseOrders/components/Detail/SRPConditionMismatchWarning";
import {
  ALTERNATE_ID,
  AS_REMOVED,
  CAP_AMOUNT,
  CAP_TYPE,
  CAP_TYPES,
  CORE_DUE_DATE,
  CORE_REPAIR_FEE_NOT_TO_EXCEED,
  DIM_WEIGHT,
  EVALUATION_PERIOD,
  EXPECTED_SERIAL_NUMBER,
  EXTERNAL_NOTE,
  HAZMAT_FEE,
  INCIDENT,
  INTERNAL_NOTE,
  PURCHASE_FOR_REPAIR,
  PURCHASE_FOR_REPAIR_ASSIST,
  PURCHASE_FOR_SALE,
  PURCHASE_FOR_STOCK,
  RESERVE_FOR_SALE_QUANTITY,
  TOOL_USED,
  WARRANTY_PERIOD
} from "MODULES/PurchaseOrders/constants";
import {
  AS_IS,
  INCOMING_LINE_ITEMS,
  PURCHASE_STATUS,
  PURCHASE_STATUS_LABEL,
  PURCHASE_STATUS_OPTIONS
} from "MODULES/IncomingQuotes/constants";
import * as actions from "MODULES/PurchaseOrders/actions";
import {
  CurrencyField,
  FormInput,
  Select,
  TextArea,
  MonthYearField,
  AutoCompleteUserInputField,
  AutoCompleteField,
  Check,
  CheckGroup
} from "MODULES/shared/components/Forms";
import DomLifeWarning from "MODULES/PurchaseOrders/components/Detail/LineItemsTable/DomLifeWarning";
import PurchaseForFields from "MODULES/PurchaseOrders/shared/PurchaseForFields";
import { USER } from "MODULES/users/constants";
import {
  CONDITION,
  EXCHANGE_SRP,
  SRP_CONDITION,
  SUGGESTED_RETAIL,
  TAG_DATE,
  TAGGED_BY,
  LEAD_TIME,
  OVERHAULED,
  INSPECTED,
  REPAIRED,
  NEW_ITEM,
  UNSELLABLE_PER_USER,
  FAA,
  EASA,
  TCCA,
  CAAC,
  OTHER,
  OTHER_TAG_TYPE,
  UK_CAA
} from "MODULES/inventories/constants";
import { COST, QUANTITY, SHIPPING_TYPE } from "APP_ROOT/constants";
import { APPROVED, DO_NOT_EXCHANGE } from "MODULES/companies/constants";
import ToolsUsedDropDown from "MODULES/Locations/components/ToolsUsedDropDown";
import { BIO_HAZMAT, DOM, HAZMAT } from "MODULES/parts/constants";
import { get, isEmpty } from "lodash";
import {
  CORE_DUE_DAYS,
  CORE_RETURN_DATE,
  EXCHANGE,
  PURCHASE_FOR_EXCHANGE
} from "MODULES/RepairOrders/constants";
import { addDays } from "LIB/time";
import {
  FLAT_EXCHANGE,
  FLAT_EXCHANGE_FEE
} from "MODULES/SalesOrders/constants";
import { toOptions } from "LIB/forms";
import { EXCHANGE_FEE } from "MODULES/OutgoingQuotes/constants";
import { useSettings } from "APP_ROOT/hooks/useCurrentUser";
import FormRow from "../../../shared/components/Forms/FormRow";
import { properCase } from "../../../../lib/formatters/text";

const formName = "incomingQuoteConvertToPurchaseOrders";

class LineItemRow extends Component {
  static propTypes = {
    getFieldValue: PropTypes.func.isRequired,
    currentUser: PropTypes.instanceOf(Map),
    lineItems: PropTypes.arrayOf(Object),
    lineItemValues: PropTypes.arrayOf(Object),
    searchBuyers: PropTypes.func.isRequired,
    shippingType: PropTypes.string,
    searchRepairStations: PropTypes.func.isRequired,
    setFieldValue: PropTypes.func.isRequired,
    item: PropTypes.string.isRequired,
    idx: PropTypes.number.isRequired,
    setPreferredRepairStationHold: PropTypes.func.isRequired,
    resetPreferredRepairStation: PropTypes.func.isRequired,
    handleTaggedBy: PropTypes.func.isRequired,
    purchaseForSale: PropTypes.bool,
    purchaseForStock: PropTypes.bool,
    purchaseForRepair: PropTypes.bool,
    srpCondition: PropTypes.string,
    condition: PropTypes.string,
    preferredRepairStationHold: PropTypes.bool,
    setTaggedByHold: PropTypes.func.isRequired,
    taggedByHold: PropTypes.bool
  };

  state = {
    selectedPreferredRepairStation: null
  };

  get lineItem() {
    const { lineItems, idx } = this.props;

    return lineItems[idx];
  }

  get repairStationRequired() {
    const { purchaseForRepair, condition, getFieldValue, item } = this.props;

    return (
      purchaseForRepair ||
      (condition === AS_REMOVED &&
        !getFieldValue(`${item}.${PURCHASE_FOR_SALE}`) &&
        !getFieldValue(`${item}.${PURCHASE_FOR_STOCK}`))
    );
  }

  handlePreferredRepairStation = company => {
    const { setPreferredRepairStationHold, item } = this.props;

    if (company && company.id) {
      setPreferredRepairStationHold(
        item,
        company.repair_station_status !== APPROVED
      );
    }
  };

  resetPreferredRepairStation = () => {
    const { resetPreferredRepairStation, item } = this.props;

    resetPreferredRepairStation(item);

    this.setState({ selectedPreferredRepairStation: null });
  };

  searchCompanies = filter =>
    api.companies
      .search({ filter, page: 1, limit: 20 })
      .then(resp => resp.data.results);

  clearPurchaseFor = (val, fields) => {
    if (!val) return null;
    return fields.forEach(f => this.props.setFieldValue(f)(false));
  };

  handleTaggedBy = company => {
    const { handleTaggedBy, setTaggedByHold, item } = this.props;

    if (company && company.id) {
      handleTaggedBy(company);
      setTaggedByHold(item, company.repair_station_status !== APPROVED);
    } else {
      setTaggedByHold(false);
    }
  };

  render() {
    const {
      lineItemValues,
      searchBuyers,
      shippingType,
      getFieldValue,
      purchaseForSale,
      searchRepairStations,
      setFieldValue,
      purchaseForStock,
      srpCondition,
      condition,
      preferredRepairStationHold,
      item,
      idx,
      taggedByHold
    } = this.props;
    const { selectedPreferredRepairStation } = this.state;

    const quoteItem = this.lineItem;
    const altOptions = quoteItem.alternates.map(a => ({
      value: a.id,
      text: a.name
    }));
    const includedInConversion = lineItemValues && lineItemValues[idx].included;
    const style = { opacity: includedInConversion ? 1 : 0.25 };

    const setField = name => [item, name].join(".");
    const capType = getFieldValue(setField(CAP_TYPE));
    const qty = getFieldValue(setField(QUANTITY));
    const cost = getFieldValue(setField(COST));
    const tagRequired = [OVERHAULED, INSPECTED, REPAIRED].includes(
      getFieldValue(setField(CONDITION))
    );
    const minOutrightValueForExchangeSettings = useSettings()
      .min_outright_value_for_exchange_consideration;
    const minOutrightValueForExchangeConsideration = parseFloat(
      minOutrightValueForExchangeSettings
    );
    const suggestedRetail = getFieldValue(`${item}.${SUGGESTED_RETAIL}`) || 0;
    const shouldCheckMinValue =
      minOutrightValueForExchangeSettings !== null &&
      minOutrightValueForExchangeSettings !== undefined;

    return (
      <tr key={`item-${quoteItem.id}`}>
        <td>{idx + 1}</td>
        <td>
          {purchaseForStock &&
            !isEmpty(srpCondition) &&
            !isEmpty(condition) &&
            srpCondition !== condition && <SRPConditionMismatchWarning />}
          {exchangeSrpNotAllowed(quoteItem.part) && <ExchangeSrpWarning />}
          <DomLifeWarning
            part={quoteItem.part}
            domFromLineItem={getFieldValue(setField(DOM))}
          />
          {taggedByHold && <UnauthorizedRepairStationSelectedWarning />}
          <table className="table">
            <tbody>
              <tr>
                <td style={{ width: "1%" }}>
                  <Field
                    name={`${item}.included`}
                    component="input"
                    type="checkbox"
                  />
                </td>
                <td style={style}>
                  {quoteItem.part.part_number} |&nbsp;
                  {
                    INCOMING_LINE_ITEMS.quoteType[quoteItem.quote_type].label
                  }{" "}
                  in&nbsp;
                  {INCOMING_LINE_ITEMS.condition[condition].abbrev}&nbsp;
                  Condition |&nbsp;
                  {qty} QTY @ {dollars(cost)}/each
                </td>
                <td className="text-right" style={style}>
                  {dollars(Number(qty) * Number(cost))}
                </td>
              </tr>
              {includedInConversion && (
                <tr>
                  <td />
                  <td>
                    <FormRow>
                      <Col md={3}>
                        <Field
                          name={setField(CONDITION)}
                          label={properCase(CONDITION)}
                          component={Select}
                          options={SRP_CONDITION_OPTIONS}
                          required
                        />
                      </Col>
                      <Col md={3}>
                        <Field
                          name={setField(QUANTITY)}
                          label="Qty"
                          component={FormInput}
                          type="number"
                          onBlur={(_ev, val) => {
                            if (Number(val) !== 1) {
                              setFieldValue(setField(EXPECTED_SERIAL_NUMBER))(
                                null
                              );
                            }
                            if (
                              Number(val) === 1 &&
                              getFieldValue(setField(PURCHASE_FOR_SALE))
                            ) {
                              setFieldValue(
                                setField(RESERVE_FOR_SALE_QUANTITY)
                              )(1);
                            }
                          }}
                          required
                        />
                      </Col>
                      <Col md={3}>
                        <Field
                          name={setField(COST)}
                          label={
                            getFieldValue(setField(PURCHASE_FOR_EXCHANGE))
                              ? "Outright Price"
                              : "Cost/Unit"
                          }
                          component={FormInput}
                          type="number"
                          required
                        />
                      </Col>
                      {getFieldValue(setField(PURCHASE_FOR_EXCHANGE)) && (
                        <Col md={3}>
                          <CurrencyField
                            name={setField(EXCHANGE_FEE)}
                            label={
                              getFieldValue(setField(FLAT_EXCHANGE))
                                ? properCase(FLAT_EXCHANGE_FEE)
                                : properCase(EXCHANGE_FEE)
                            }
                            disabled={
                              quoteItem.part && quoteItem.part.pass_fail
                            }
                            required
                          />
                        </Col>
                      )}
                    </FormRow>
                    <FormRow>
                      <Col md={2}>
                        <CheckGroup title={properCase(EXCHANGE)}>
                          <Field
                            name={setField(PURCHASE_FOR_EXCHANGE)}
                            label={properCase(EXCHANGE)}
                            icon="fa-check-circle"
                            component={Check}
                            disabled={
                              quoteItem.part && quoteItem.part.pass_fail
                            }
                            onChange={(_evt, val) => {
                              if (val) {
                                [
                                  PURCHASE_FOR_REPAIR,
                                  PURCHASE_FOR_STOCK,
                                  PURCHASE_FOR_REPAIR_ASSIST
                                ].forEach(f =>
                                  setFieldValue(setField(f))(false)
                                );
                                if (
                                  Number(getFieldValue(setField(QUANTITY))) ===
                                  1
                                ) {
                                  setFieldValue(
                                    setField(RESERVE_FOR_SALE_QUANTITY)
                                  )(1);
                                }
                                setFieldValue(setField(PURCHASE_FOR_SALE))(val);
                                setFieldValue(setField(CORE_DUE_DAYS))(30);
                                const days = addDays(new Date(), 30);
                                setFieldValue(setField(CORE_RETURN_DATE))(
                                  new Date(days).toISOString().split("T")[0]
                                );
                              }
                            }}
                          />
                        </CheckGroup>
                      </Col>
                      {getFieldValue(setField(PURCHASE_FOR_EXCHANGE)) && [
                        <Col md={2}>
                          <CheckGroup title={properCase(FLAT_EXCHANGE)}>
                            <Field
                              name={setField(FLAT_EXCHANGE)}
                              label={properCase(FLAT_EXCHANGE)}
                              icon="fa-check-circle"
                              component={Check}
                            />
                          </CheckGroup>
                        </Col>,
                        <Col md={2}>
                          <Field
                            name={setField(CORE_DUE_DAYS)}
                            component={FormInput}
                            label={properCase(CORE_DUE_DAYS)}
                            onChange={(_evt, val) => {
                              if (val) {
                                const days = addDays(new Date(), Number(val));
                                setFieldValue(setField(CORE_RETURN_DATE))(
                                  new Date(days).toISOString().split("T")[0]
                                );
                              }
                            }}
                            required
                          />
                        </Col>,
                        <Col md={3}>
                          <Field
                            label={properCase(CORE_DUE_DATE)}
                            name={setField(CORE_RETURN_DATE)}
                            component={FormInput}
                            type="date"
                            required
                          />
                        </Col>,
                        <Col md={3}>
                          <CurrencyField
                            label="Avg Repair (NTX)"
                            name={setField(CORE_REPAIR_FEE_NOT_TO_EXCEED)}
                            required={getFieldValue(setField(FLAT_EXCHANGE))}
                          />
                        </Col>
                      ]}
                    </FormRow>
                    <PurchaseForFields
                      prefix={`${item}`}
                      formName={formName}
                      getFieldValue={getFieldValue}
                      clearPurchaseFor={this.clearPurchaseFor}
                      selectedReserveForSeller={this.props.currentUser}
                      searchBuyers={searchBuyers}
                      setFieldValue={this.props.setFieldValue}
                      shippingType={shippingType}
                      condition={getFieldValue(setField(CONDITION))}
                      onPurchaseForStockChange={
                        this.resetPreferredRepairStation
                      }
                      onPurchaseForSaleChange={val => {
                        const fieldName = setField(RESERVE_FOR_SALE_QUANTITY);
                        if (
                          val &&
                          [undefined, 1, "1"].includes(
                            getFieldValue(setField(QUANTITY))
                          )
                        ) {
                          setFieldValue(fieldName)(1);
                        }
                        if (!val) setFieldValue(fieldName)("");
                      }}
                    />
                    <FormRow>
                      <Col md={3}>
                        <Field
                          name={`${item}.${ALTERNATE_ID}`}
                          label="Buy As Alternate"
                          placeholder="Type a part's number..."
                          component={Select}
                          options={altOptions}
                          addon={<i className="fa fa-exchange" />}
                          disabled={altOptions.length === 0}
                        />
                      </Col>
                      <Col md={3}>
                        <Field
                          name={`${item}.${SRP_CONDITION}`}
                          component={Select}
                          options={SRP_CONDITION_OPTIONS}
                          label="SRP Condition"
                          required={!purchaseForSale}
                        />
                      </Col>
                      <Col md={3}>
                        <CurrencyField
                          name={`${item}.${SUGGESTED_RETAIL}`}
                          label="SRP"
                          required={!purchaseForSale}
                        />
                      </Col>
                      <Col md={3}>
                        <CurrencyField
                          name={`${item}.${EXCHANGE_SRP}`}
                          label="Exchange SRP"
                          required={
                            (!shouldCheckMinValue ||
                              suggestedRetail >=
                                minOutrightValueForExchangeConsideration) &&
                            !purchaseForSale &&
                            !exchangeSrpNotAllowed(quoteItem.part) &&
                            ![NEW_ITEM, AS_REMOVED].includes(
                              getFieldValue(setField(CONDITION))
                            ) &&
                            !getFieldValue(setField(DO_NOT_EXCHANGE))
                          }
                          disabled={
                            exchangeSrpNotAllowed(quoteItem.part) ||
                            getFieldValue(setField(DO_NOT_EXCHANGE))
                          }
                        />
                      </Col>
                    </FormRow>
                    <FormRow>
                      <Col md={3}>
                        <div className="form-group">
                          <MonthYearField
                            name={`${item}.${DOM}`}
                            component={FormInput}
                            label={DOM.toUpperCase()}
                          />
                        </div>
                      </Col>
                      <Col md={3}>
                        <MonthYearField
                          name={`${item}.${TAG_DATE}`}
                          label={properCase(TAG_DATE)}
                          component={FormInput}
                          required={tagRequired}
                        />
                      </Col>
                      <Col md={3}>
                        <Field
                          component={AutoCompleteUserInputField}
                          selectedItem={this.lineItem.tagged_by}
                          formatItem={result =>
                            (typeof result === "object"
                              ? result.name
                              : result) || ""}
                          handleTaggedBy={this.handleTaggedBy}
                          label={properCase(TAGGED_BY)}
                          name={`${item}.${TAGGED_BY}`}
                          placeholder="Search by a company's name"
                          required={tagRequired}
                          search={this.searchCompanies}
                        />
                      </Col>
                      <Col md={3}>
                        <Field
                          component={FormInput}
                          label="Expected Serial #"
                          name={setField(EXPECTED_SERIAL_NUMBER)}
                          disabled={Number(qty) !== 1}
                        />
                      </Col>
                    </FormRow>
                    <FormRow>
                      <Col md={2}>
                        <Field
                          name={`${item}.${LEAD_TIME}`}
                          component={FormInput}
                          label="Lead Time (Days)"
                          required
                        />
                      </Col>
                      <Col md={3}>
                        <Field
                          name={setField(PURCHASE_STATUS)}
                          component={Select}
                          options={PURCHASE_STATUS_OPTIONS}
                          label={PURCHASE_STATUS_LABEL}
                          required
                        />
                      </Col>
                      <Col md={2}>
                        <ToolsUsedDropDown name={setField(TOOL_USED)} />
                      </Col>
                      <Col md={2}>
                        <CheckGroup title="As-is">
                          <FormSection name={item}>
                            <Fields
                              names={[
                                AS_IS,
                                CONDITION,
                                EVALUATION_PERIOD,
                                PURCHASE_FOR_STOCK
                              ]}
                              component={AsIsField}
                            />
                          </FormSection>
                        </CheckGroup>
                      </Col>
                      <Col md={2}>
                        <Field
                          name={`${item}.warranty_period`}
                          component={Select}
                          options={toOptions(WARRANTY_PERIOD)}
                          label="Warranty Period"
                        />
                      </Col>
                    </FormRow>
                    <FormRow>
                      <Col md={3}>
                        <Field
                          name={`${item}.preferred_repair_station_id`}
                          label="Suggested Repair Station"
                          placeholder="Type a vendor's name or code..."
                          component={AutoCompleteField}
                          search={searchRepairStations}
                          selectedItem={selectedPreferredRepairStation}
                          formatItem={result => result && result.name}
                          disabled={purchaseForStock}
                          required={this.repairStationRequired}
                          watch={
                            purchaseForStock && selectedPreferredRepairStation
                          }
                          onItemSelected={this.handlePreferredRepairStation}
                        />
                      </Col>
                      <Col md={3}>
                        <Field
                          name={setField(EVALUATION_PERIOD)}
                          type="number"
                          component={FormInput}
                          label="Eval. Period"
                        />
                      </Col>
                      <Col md={3}>
                        <Field
                          name={setField(CAP_TYPE)}
                          className="text-right"
                          component={Select}
                          options={toOptions(CAP_TYPES)}
                          label="Repair/Overhaul Cap"
                          onChange={(_, val) => {
                            if (!val) {
                              setFieldValue(setField(CAP_AMOUNT))(null);
                            }
                          }}
                        />
                      </Col>

                      <Col md={3}>
                        <CurrencyField
                          name={setField(CAP_AMOUNT)}
                          label={`${get(
                            CAP_TYPES,
                            `${capType}.label`,
                            ""
                          )} Cap Amount`}
                          disabled={isEmpty(capType)}
                        />
                      </Col>
                    </FormRow>
                    <FormRow>
                      <Col md={5}>
                        <div className="form-group">
                          <label htmlFor="warnings" className="control-label">
                            Line Hazmat
                          </label>
                          <br />
                          <FormSection name={item}>
                            <Fields
                              names={[HAZMAT, BIO_HAZMAT]}
                              component={LineHazmatFields}
                            />
                          </FormSection>
                        </div>
                      </Col>
                      <Col md={3}>
                        <CheckGroup title="Heavy Package / DIM WT" justified>
                          <Field
                            name={setField(DIM_WEIGHT)}
                            component={Check}
                            label="Hvy Pkg / DIM"
                            icon="fa-check-circle"
                          />
                        </CheckGroup>
                      </Col>
                      <Col md={2}>
                        <CheckGroup title={properCase(INCIDENT)} justified>
                          <Field
                            name={setField(INCIDENT)}
                            label={properCase(INCIDENT)}
                            component={Check}
                            icon="fa-check-circle"
                          />
                        </CheckGroup>
                      </Col>
                      {getFieldValue(setField(HAZMAT)) && (
                        <Col md={2}>
                          <CurrencyField
                            name={setField(HAZMAT_FEE)}
                            label={properCase(HAZMAT_FEE)}
                            required
                          />
                        </Col>
                      )}
                    </FormRow>
                    <FormRow>
                      <Col md={3}>
                        <CheckGroup title="Do Not Sell!" justified>
                          <Field
                            name={setField(UNSELLABLE_PER_USER)}
                            component={props => (
                              <Check {...props} icon="fa-diamond" />
                            )}
                            label="Do Not Sell!"
                          />
                        </CheckGroup>
                      </Col>
                      <Col md={3}>
                        <CheckGroup title="Do Not Exchange" justified>
                          <Field
                            name={setField(DO_NOT_EXCHANGE)}
                            label={properCase(DO_NOT_EXCHANGE)}
                            component={Check}
                            onChange={(_, val) => {
                              if (val) {
                                setFieldValue(setField(EXCHANGE_SRP))("");
                              }
                            }}
                          />
                        </CheckGroup>
                      </Col>
                    </FormRow>
                    <FormRow>
                      <Col md={12}>
                        {preferredRepairStationHold && (
                          <UnauthorizedPreferredRepairStationSelectedWarning />
                        )}
                      </Col>
                    </FormRow>
                    <FormRow>
                      <Col md={12}>
                        <div
                          className="form-group"
                          style={{ cursor: "pointer" }}
                        >
                          <label className="control-label" htmlFor="tag_type">
                            Release Type
                          </label>
                          <div
                            id="tag_type"
                            className="btn-group btn-group-justified"
                            data-toggle="buttons"
                          >
                            <Field
                              component={Check}
                              name={setField(FAA)}
                              label={FAA.toUpperCase()}
                              icon="fa-check-circle"
                            />
                            <Field
                              component={Check}
                              name={setField(EASA)}
                              label={EASA.toUpperCase()}
                              icon="fa-check-circle"
                            />
                            <Field
                              component={Check}
                              name={setField(UK_CAA)}
                              label={UK_CAA.toUpperCase()}
                              icon="fa-check-circle"
                            />
                            <Field
                              component={Check}
                              name={setField(TCCA)}
                              label={TCCA.toUpperCase()}
                              icon="fa-check-circle"
                            />
                            <Field
                              component={Check}
                              name={setField(CAAC)}
                              label={CAAC.toUpperCase()}
                              icon="fa-check-circle"
                            />
                            <Field
                              component={Check}
                              name={setField(OTHER)}
                              label={OTHER.toUpperCase()}
                              onChange={val => {
                                if (!val)
                                  setFieldValue(setField(OTHER_TAG_TYPE))("");
                              }}
                              icon="fa-check-circle"
                            />
                          </div>
                        </div>
                        {!getFieldValue(setField(OTHER)) ? null : (
                          <FormRow>
                            <Col md={5}>
                              <Field
                                component={FormInput}
                                name={setField(OTHER_TAG_TYPE)}
                                label={properCase(OTHER_TAG_TYPE)}
                                maxLength={10}
                                max={10}
                              />
                            </Col>
                          </FormRow>
                        )}
                      </Col>
                    </FormRow>

                    <FormRow>
                      <Col md={6}>
                        <Field
                          name={setField(INTERNAL_NOTE)}
                          rows={5}
                          cols={50}
                          component={TextArea}
                          label={properCase(INTERNAL_NOTE)}
                        />
                      </Col>
                      <Col md={6}>
                        <Field
                          name={setField(EXTERNAL_NOTE)}
                          rows={5}
                          cols={50}
                          component={TextArea}
                          label={properCase(EXTERNAL_NOTE)}
                        />
                      </Col>
                    </FormRow>
                  </td>
                  <td />
                </tr>
              )}
            </tbody>
          </table>
        </td>
      </tr>
    );
  }
}

const selector = formValueSelector(formName);

export default connect(
  (state, props) => ({
    getFieldValue: field => formValueSelector(formName)(state, field),
    currentUser: state.session.get(USER).toJS(),
    lineItemValues: selector(state, "line_items"),
    shippingType: selector(state, SHIPPING_TYPE),
    purchaseForRepair: selector(state, `${props.item}.purchase_for_repair`),
    purchaseForStock: selector(state, `${props.item}.purchase_for_stock`),
    purchaseForSale: selector(state, `${props.item}.purchase_for_sale`),
    srpCondition: selector(state, `${props.item}.srp_condition`),
    condition: selector(state, `${props.item}.condition`),
    preferredRepairStationHold: selector(
      state,
      `${props.item}.preferred_repair_station_hold`
    ),
    taggedByHold: selector(state, `${props.item}.tagged_by_hold`)
  }),
  dispatch => ({
    searchRepairStations: filter =>
      dispatch(actions.searchRepairStations(filter)),
    searchBuyers: filter => dispatch(actions.searchBuyers(filter)),
    resetPreferredRepairStation: item =>
      dispatch(change(formName, `${item}.preferred_repair_station_id`, "")),
    setFieldValue: field => val => dispatch(change(formName, field, val)),
    setPreferredRepairStationHold: (item, hold) =>
      dispatch(change(formName, `${item}.preferred_repair_station_hold`, hold)),
    setTaggedByHold: (item, hold) =>
      dispatch(change(formName, `${item}.tagged_by_hold`, hold))
  })
)(LineItemRow);



// WEBPACK FOOTER //
// ./app/modules/IncomingQuotes/Detail/ConvertToPurchaseOrder/LineItemRow.jsx